import React from 'react';
import { useState } from 'react';

const MultiSelectDropdown = ({ label, list, selectedlist, itemClick }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="w-full">
      <button
        type="button"
        onClick={() => setIsVisible(!isVisible)}
        className="m-0 w-full flex items-center justify-between gap-2 rounded-sm border border-yellow-600/30 bg-black/50 px-2.5 py-2 text-left"
        style={{ margin: 0, width: '100%' }}
      >
        <span className="text-[10px] font-semibold uppercase tracking-[0.12em] text-yellow-500/90">
          {label}
        </span>
        <span className="text-[10px] text-zinc-500">{isVisible ? '▴' : '▾'}</span>
      </button>
      {isVisible && (
        <div className="mt-1 max-h-40 overflow-y-auto rounded-sm border border-yellow-600/25 bg-zinc-950 shadow-lg">
          {(list || []).map((item, key) => {
            const isSelected = selectedlist.includes(item);
            return (
              <button
                key={key}
                type="button"
                onClick={() => itemClick(item)}
                className={`m-0 w-full px-2.5 py-1.5 text-left text-[11px] border-b border-zinc-900 last:border-0 transition-colors ${
                  isSelected
                    ? 'bg-yellow-500/15 text-yellow-300'
                    : 'text-zinc-300 hover:bg-yellow-500/5 hover:text-yellow-400'
                }`}
                style={{ margin: 0, width: '100%' }}
              >
                {item}
              </button>
            );
          })}
          {!(list || []).length && (
            <p className="px-2.5 py-2 text-[11px] text-zinc-600">No options</p>
          )}
        </div>
      )}
    </div>
  );
};

export default MultiSelectDropdown;
